export const isElement = (node: Node | EventTarget): node is HTMLElement =>
  node instanceof HTMLElement;
